module.exports = __webpack_public_path__ + "f35b3c4fa8a51329b4d269ee15a4ea49.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image8.png
// module id = Drf4
// module chunks = 0